import { MAX_RELOAD_ATTEMPTS } from '../../constants/cartLoad';
import { fallbackToEmptyArray } from '../utils/fallbackHelper';

const selectIsLoaded = cart => cart.isLoaded;
const selectIsOutdated = cart => cart.isOutdated;
const selectCartError = cart => cart.error;
const selectIsCartLoadError = cart => Boolean(cart.error);
const selectTenant = cart => cart.tenant;
const selectShopperId = cart => cart.shopperId;
const selectCartId = cart => cart.cartId;
const selectPendingItemsCount = cart => cart.pendingItemsCount;
const selectPendingItemSummaries = cart => cart.pendingItemSummaries;
const selectPendingOperations = cart =>
  fallbackToEmptyArray(cart.pendingOperations);
const selectLegalRequirements = cart => cart.legalRequirements;
const selectReadyToEnterCheckout = cart =>
  !!cart.checkoutValidity && !!cart.checkoutValidity.readyToEnterCheckout;
const selectAreAnyProductSpecsInvalid = cart => {
  if (
    cart.checkoutValidity &&
    Array.isArray(cart.checkoutValidity.validityChecks)
  ) {
    const externalValidityCheck = cart.checkoutValidity.validityChecks.find(
      validityCheck => validityCheck.name === 'productSpecValid'
    );
    if (externalValidityCheck && !externalValidityCheck.valid) {
      return true;
    }
  }
  return false;
};
const selectInvalidValidityChecks = cart =>
  cart.checkoutValidity?.validityChecks
    ?.filter(check => !check.valid)
    .map(check => check.name) || [];
const selectIsCToolsOffline = cart => {
  if (
    cart.checkoutValidity &&
    Array.isArray(cart.checkoutValidity.validityChecks)
  ) {
    const cToolsDownCheck = cart.checkoutValidity.validityChecks.find(
      validityCheck => validityCheck.name === 'cToolsOnline'
    );
    if (cToolsDownCheck && !cToolsDownCheck.valid) {
      return true;
    }
  }
  return false;
};
const selectIsEligibleForAnonymousPurchase = cart => {
  const eligibleForAnonymousPurchaseCheck =
    cart.checkoutValidity?.validityChecks?.find(
      check => check.name === 'eligibleForAnonymousPurchase'
    );
  // default to true if validity check is not present
  if (!eligibleForAnonymousPurchaseCheck) {
    return true;
  }
  return eligibleForAnonymousPurchaseCheck?.valid;
};
const selectAreAnyItemsPricingInvalid = cart =>
  selectInvalidValidityChecks(cart).includes('itemPricing');

const selectPendingOperationReloadAttemptCount = cart =>
  cart.pendingOperationReloadAttemptCount;
const selectIsPendingShippingOperationInProgress = cart => {
  const shippingOperations = ['SHIPPING_OPTIONS', 'SHIPPING_OPTIONS_PRICING'];
  const pendingOperationTypes = selectPendingOperations(cart).map(
    po => po.type
  );
  return shippingOperations.some(so => pendingOperationTypes.includes(so));
};
const selectDidCartLoadHitMaxReloadAttempts = cart => {
  const reloadCount = selectPendingOperationReloadAttemptCount(cart);
  return reloadCount >= MAX_RELOAD_ATTEMPTS;
};

const selectLastModifiedDate = cart => cart.lastModifiedDate;

export default {
  selectIsLoaded,
  selectIsOutdated,
  selectIsCartLoadError,
  selectTenant,
  selectShopperId,
  selectCartError,
  selectCartId,
  selectPendingItemsCount,
  selectPendingItemSummaries,
  selectLegalRequirements,
  selectIsCToolsOffline,
  selectPendingOperations,
  selectReadyToEnterCheckout,
  selectAreAnyProductSpecsInvalid,
  selectInvalidValidityChecks,
  selectIsEligibleForAnonymousPurchase,
  selectAreAnyItemsPricingInvalid,
  selectPendingOperationReloadAttemptCount,
  selectIsPendingShippingOperationInProgress,
  selectDidCartLoadHitMaxReloadAttempts,
  selectLastModifiedDate,
};
